import { HelpService } from './../../help/help.service';
import { Title } from '@angular/platform-browser';
import { TaskService, Task } from './../../task/task.service';
import { SettingsService } from './../../settings/settings.service';
import {
	StockService,
	UpdateRootCauseOuput,
	DeepDiveColumnData,
	DeepDiveDropdownElement,

	DeepDiveDetailsTable,
	DeepDiveDetailsIssuesTable,
	DeepDiveRowData,
	DeepDiveParamsTable,
	DeepDiveDetailsIssueItem,
} from './../stock.service';
import { TableDataOperator } from 'src/app/operators/table-data.operator';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GridHelper } from 'src/app/helpers/grid-helper';
import { DxChartComponent, DxDataGridComponent, DxRangeSelectorComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ListElementEnum } from 'src/app/enums/listElementEnum';
import { AutocompleteComponent, DevTooltipCustComponent } from 'src/app/widgets';
import DataSource, { Options } from 'devextreme/data/data_source';
import { UtilsService } from 'src/app/services/utils.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { ShareDataService } from 'src/app/services/share-data.service';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { AppDevNotifyComponent } from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';

@Component({
	selector: 'app-deep-dive',
	templateUrl: './deep-dive.component.html',
	styleUrls: ['./deep-dive.component.scss'],
	standalone: false
})
export class DeepDiveComponent implements OnInit {
	// Task data
	tasks: Task[] = [];
	showTasksPopup = false;
	showAddTaskPopup = false;
	currentUrl = '';
	activeTasksForCurrentPage = false;
	activeTasks: Task[] = [];
	showInfoPopup = false;
	infoPopupMessage = '';
	infPopupTitle = '';
	//chart value range
	visualRange: any = {};
	visualSalesFoecastRange: any = {};

	//Grid Variables
	currentStockControllingId = "";
	products: DeepDiveRowData[] = [];
	public selectedProductCode: string = '';
	gridColumns: DeepDiveColumnData[];
	product: DeepDiveRowData;
	rootCauseTable = new DeepDiveDetailsTable();
	esoObjectTable: DeepDiveDetailsIssuesTable;
	esoObjectTableItems: DeepDiveDetailsIssueItem[] = [];
	parametersTable: DeepDiveParamsTable[] = [];

	fitTableToPage = false;

	//Charts Variables
	chartsDataSource = {};
	stockChartCaption: any = [];
	//Auto Complete Variables
	autoCompleteProductDataSource: string[] = [];

	comment = '';
	dropdownElement: DeepDiveDropdownElement[] = [];

	//Save Message
	message = '';
	successMsg = '';
	deadlineMessage = '';
	startDateMessage = '';
	selectedRootCause = '';
	selectedRootCauseId = 0;
	selectedItem = '';
	SecondHeaderName = '';
	IsPageLoadGridChange = false;
	//ProductImage
	ProductImageHeight: any;
	ProductImagePath: any;
	ProductImageWidth: any;
	imgSrc: string;
	ImgTitle: string;
	ImageInfoPopup: boolean;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;
	@ViewChild(DxSelectBoxComponent, { static: false }) rootCase: DxSelectBoxComponent;
	@ViewChild('autocomplete')
	autocomplete: AutocompleteComponent;
	@ViewChild("stockDevelopmentChartRangSelct", { static: false }) dxStockDevelopmentChartRangSelct: DxRangeSelectorComponent;
	@ViewChild("stockActualSalesDevelopmentRangSelct", { static: false }) dxStockActualSalesDevelopmentRangSelct: DxRangeSelectorComponent;
	@ViewChild("stockDevelopmentChart", { static: false }) dxStockDevelopmentChart: DxChartComponent;
	@ViewChild("stockActualSalesDevelopmentChart", { static: false }) dxstockActualSalesDevelopmentChart: DxChartComponent;


	constructor(
		private stockService: StockService,
		private route: ActivatedRoute,
		private location: Location,
		private taskService: TaskService,
		private titleService: Title, private shareDataService: ShareDataService,
		private helpService: HelpService, private fileExportService: FileExportService,
		private settingsService: SettingsService,
		private tableParamService: TableParameterService
	) { this.shareDataService.CleanData(); }
	

		public pageFiltersOperator: FiltersOperator = new FiltersOperator(
			new SelectStatementOptions(
			  {
				filters: async () => this.pageFiltersOperator.appliedFilters,
		
				baseSelectStatementId: BaseSelectStatementId.EsoOverviewGridData,
				selectionSetId: SelectionSetId.EsoOverviewFilters,
			  }
			)
		);
	public tableDataOperator: TableDataOperator = new TableDataOperator(
			new SelectStatementOptions(
				{

					baseSelectStatementId: BaseSelectStatementId.EsoOverviewGridData,
					selectionSetId: SelectionSetId.EsoOverviewList,
				}
			)
		);
	ngOnInit() {
		this.titleService.setTitle("Stock Deep Dive");

		this.initDropDown();
		this.initProductId();
		this.getOverviewStockDataDeepDive('0');
		this.getTasksForCurrentPage();

		this.currentUrl = this.location.path();

		this.WebSettingsPivot();
		this.GetSettingsData();
		this.SettingsGroupByName();
		this.getDataType();
	}

	DataType = [];
	getDataType() {
		this.settingsService.SelectDataTypeSelection("StockDeepDive").subscribe(datatypes => {
			if (datatypes && datatypes.dataTypes) {
				this.DataType = datatypes.dataTypes;
				this.loadDataTypes();
			}
		}, err => {
			console.log(err, "err");
		});
	}
	loadDataTypes() {
		if (this.DataType && this.gridColumns) {
			this.DataType.forEach(itemData => {
				if (itemData.name == 'List') {
					this.gridColumns.forEach(itemColmn => {
						if (itemData.selectionName.toLocaleLowerCase() == itemColmn.fieldName.toLocaleLowerCase()) {
							if (itemData.dataTypeFormat) {
								itemColmn.dataFormat = itemData.dataTypeFormat;
							}
							if (itemData.dataType) {
								itemColmn.dataType = itemData.dataType;
							}
						}
					});
				}

				if (itemData.name == 'Issue') {
					this.esoObjectTableItems.forEach(itemColmn => {
						if (itemData.selectionName.toLocaleLowerCase() == itemColmn.fieldName.toLocaleLowerCase()) {
							if (itemData.dataTypeFormat) {
								itemColmn.dataFormat = itemData.dataTypeFormat;
							}
							if (itemData.dataType) {
								itemColmn.dataType = itemData.dataType;
							}
						}
					});
				}

			});
		}
	}

	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportStockDeepDivelist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}
	SettingsGroupByName() {

		this.settingsService.SettingsGroupByName("EsoObjectProductImagePath", "ESO Captions").subscribe(result => {

			let imag = result.table.find((x: { name: string; }) => x.name == "EsoObjectProductImagePath");

			this.ProductImagePath = imag.value;
			let imageheight = result.table.find((x: { name: string; }) => x.name == "EsoObjectProductImageHeight");
			this.ProductImageHeight = imageheight.value;
		});

	}
	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	private getTasksForCurrentPage() {
		this.taskService.getTasksForUrl(this.location.path()).subscribe(result => {
			this.tasks = result;

			if (this.tasks.length > 0) {
				this.activeTasksForCurrentPage = true;
			} else {
				this.activeTasksForCurrentPage = false;
			}
		});
	}

	private getOverviewStockDataDeepDive(itemId: string) {
		this.stockService.getDeepDiveData('DY', itemId)
			.subscribe(result => {
				if (itemId && itemId != "0") {
					let item = new DeepDiveRowData;
					result.values.forEach(function (data) {
						item = data
					});
					let indexProduct = this.products.findIndex(x => x.productId == itemId);
					if (indexProduct != null && indexProduct != undefined && indexProduct != -1 && indexProduct > -1 && item && item.productId) {
						this.products[indexProduct] = item;
					}
				}
				else {
					result.fields.forEach(item => {
						item.fieldName = item.fieldName.charAt(0).toLocaleLowerCase() + item.fieldName.substring(1);
					});

					this.gridColumns = [];

					result.fields.forEach(element => {
						let dataCType = "string";
						if (element.fieldName == "invDiff_Amount" || element.fieldName == "actualStock") {
							dataCType = "number";
						}
						this.gridColumns.push({
							fieldName: element.fieldName,
							caption: element.caption,
							dataType: dataCType,
							dataFormat: null
						});

					});

					this.products = result.values;
					this.autoCompleteProductDataSource = this.products.map(product => product.productId);
					if (this.route.snapshot && this.route.snapshot.queryParamMap && this.route.snapshot.queryParamMap.get("id")) {
						const productId = UtilsService.getURLHelperDeconding(this.route.snapshot.queryParamMap.get("id"));
						this.location.go(`stock/deep-dive?id=${UtilsService.getURLHelper(productId)}`);
						if (this.IsPageLoadGridChange) {
							this.getProductData(productId);
						}
						this.IsPageLoadGridChange = true;
						setTimeout(() => this.autocomplete.setSelectedItem(productId));
					}
					this.dataFilter = new BookmarkData();
					this.dataFilter.BookmarkId = 0;
					this.dataFilter.name = "DefBokmk";
					this.dataFilter.pageName = this.pageName;
					this.loadBookMarkFilter();
					this.loadDataTypes();

				}
			});
	}

	onLegendClick(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}

	initDropDown() {

		this.stockService.getDeepDiveDropdownData(ListElementEnum.RootCause.toString()).subscribe(res => {
			this.dropdownElement = res;
		});
	}

	showTasksForCurrentUrl() {
		this.getTasksForCurrentPage();
		this.currentUrl = this.location.path();

		if (this.tasks.length > 0) {
			this.showTasksPopup = true;
		} else {
			this.showAddTaskPopup = true;
		}
	}

	saveComment() {
		const comment = new UpdateRootCauseOuput();
		comment.productId = this.selectedProductCode;
		if (this.selectedProductCode != null && this.selectedProductCode != '0') {

		}

		comment.rootCause = this.selectedRootCause;
		comment.rootCauseComment = this.comment;

		if (!comment.productId || (!comment.rootCauseComment && !comment.rootCause)) {
			return;
		}


		this.stockService.updateDeepDiveRootCause(comment).subscribe(
			() => {
				this.getOverviewStockDataDeepDive(this.selectedProductCode);

			},
			error => console.log(error)
		)
			.add(() => { });
	}

	useLastRootComment() {
		if (!this.rootCauseTable || !this.rootCauseTable.lastRootCause || this.rootCauseTable.lastRootCause === '') {
			alert('Last root cause is blank.');
			return;
		}

		this.setSelectedRootCauseId(this.rootCauseTable.lastRootCause);
		this.selectedRootCause = this.rootCauseTable.lastRootCause;
		this.comment = this.rootCauseTable.lastRootCauseComment;
	}

	private initProductId() {
		this.route.paramMap.subscribe(
			params => {

				if (this.route.snapshot.queryParamMap.get("id")) {
					const value = UtilsService.getURLHelperDeconding(this.route.snapshot.queryParamMap.get("id"));
					this.selectedProductCode = value ? value : '0';
					if (this.selectedProductCode) {
						this.getProductData(this.selectedProductCode);
					}
				} else {
					this.getProductData("0");
				}
			});
	}

	changeProductId(e, data) {
		e.event.stopPropagation();
		this.location.go(`stock/deep-dive?id=${UtilsService.getURLHelper(data.data.productId)}`);
		this.getProductData(data.data.productId);
		setTimeout(() => this.autocomplete.setSelectedItem(data.data.productId));
		this.getTasksForCurrentPage();
	}

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift({
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'bookmarkButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	getProductData(item?: any) {

		const code = item ? item : null;
		this.selectedProductCode = code;
		this.stockService.getStockControllingDeepDiveProductDetails(code).subscribe(res => {

			if (res.access[0].flag == 0) {

				AppDevNotifyComponent.ErrorMessage(res.access[0].msg);
			}
			else {
				this.chartsDataSource = res.deepDives;
				this.stockChartCaption = res.stockDeepDiveChartCaption;
				this.initParamTable(res.esoDeepDives);
				if (res.esoDeepDives[0]) {
					this.rootCauseTable = res.esoDeepDives[0];
					if (res.esoDeepDives[0].headerTitle != null) {
						this.selectedItem = res.esoDeepDives[0].headerTitle;
						this.currentStockControllingId = res.esoDeepDives[0].currentStockControllingId;
						if (this.selectedProductCode == null || this.selectedProductCode == '0') {
							this.selectedProductCode = res.esoDeepDives[0].headerTitle;
						}
					}
					if (res.esoDeepDives[0].secondHeaderName != null) {
						this.SecondHeaderName = res.esoDeepDives[0].secondHeaderName;
					}

					this.comment = this.rootCauseTable.rootCauseComment;
					this.setSelectedRootCauseId(this.rootCauseTable.rootCause);
				}
				if (res.esoDeepDiveIssues) {
					if (!res || !res.esoDeepDiveIssues || !res.esoDeepDiveIssues.items || res.esoDeepDiveIssues.items.length < 1) {
						this.esoObjectTable = null;
						this.esoObjectTableItems = [];
					} else {
						this.esoObjectTable = res.esoDeepDiveIssues;
						this.esoObjectTableItems = res.esoDeepDiveIssues.items;
					}
				}
				this.onResize();
				this.location.go(`stock/deep-dive?id=${UtilsService.getURLHelper(this.selectedProductCode)}`);
				this.getTasksForCurrentPage();

				this.loadDataTypes();
				this.handleChartsAndLegends();
			}
		},
			error => console.log(error),
			() => {
				this.setDefaultRootCauseValue();
			}
		);
		if (item) {
			this.scrollTop();
		}
	}

	initParamTable(arr: DeepDiveDetailsTable[]) {
		arr.forEach((key, obj) => {
			this.parametersTable.push({ title: key, desc: obj });
		});
	}


	scrollTop() {
		const el = document.getElementById('anchor');
		setTimeout(() => {
			if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
		}, 1);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	initRootCause(selectedRootCause: DeepDiveDropdownElement) {
		if (!selectedRootCause) {
			return;
		}
		this.selectedRootCause = selectedRootCause.listElement;
	}

	setDefaultRootCauseValue() {
		this.comment = this.rootCauseTable.rootCauseComment;
		this.setSelectedRootCauseId(this.rootCauseTable.rootCause);
		this.rootCase.value = 0;
		this.rootCase.text = '';
	}

	private setSelectedRootCauseId(rootCause: string) {
		let dropDownElement = this.dropdownElement.filter(item => item.listElement === rootCause)[0];
		this.selectedRootCauseId = dropDownElement ? dropDownElement.listElementId : 0;
	}

	gridFilterChanged(event: any) {
		let filters = event.component.getCombinedFilter();
		let condition = GridHelper.generateFilterConditionByColumnFilters(filters, false);

		if (condition) {
			let data = this.products.filter(condition);
			this.autocomplete.setSelectedItem(null);
			this.autoCompleteProductDataSource = data.map(product => product.productId);
		}
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		//creating new data source
		let gridData = new DataSource(
			<Options>
			{
				store: this.dataGrid.dataSource,
				paginate: false
			}
		);


		//Getting all Filtering
		let filterExpr = evt.component.getCombinedFilter();
		if (filterExpr != null) {
			gridData.filter(filterExpr);
		}

		//Getting all sorting
		let sortingExpres = evt.component.getDataSource().sort();
		if (sortingExpres != null) {
			gridData.sort(sortingExpres);
		}


		gridData.load().then((result) => {
			let data = result.map(product => product);
			this.autoCompleteProductDataSource = data.map(product => product.productId);
		});

		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-stock-deep', JSON.stringify(this.dataGrid.instance.state()));
	}

	public onHelpButtonClicked(event, settingName: string) {
		this.helpService.openHelpPage(settingName);
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		if (info != null && info.points != null) {
			let SafetyStock = info.points.find(x => x.seriesName == "SafetyStock");
			if (SafetyStock != null && SafetyStock.originalValue != null) {
				info.points.forEach(element => {
					if (element != null && element.seriesName == "Safety Stock+lot size") {
						element.originalValue = element.originalValue + SafetyStock.originalValue;
					}
				});
			}
		}
		return DevTooltipCustComponent.customizeTooltip(info, "Stock (Qty)", "", "");
	}

	customizeTooltipTop = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "Actual Sales vs. Forecast (Qty)", "", "");
	}

	onResize() {
		setTimeout(() => {

			this.LoadChartSeries();

			if (this.dxStockDevelopmentChart && this.dxStockDevelopmentChart.instance) {
				this.dxStockDevelopmentChart.instance.refresh();
			}
			if (this.dxstockActualSalesDevelopmentChart && this.dxstockActualSalesDevelopmentChart.instance) {
				this.dxstockActualSalesDevelopmentChart.instance.refresh();
			}
			if (this.dxStockDevelopmentChartRangSelct && this.dxStockDevelopmentChartRangSelct.instance) {
				this.dxStockDevelopmentChartRangSelct.instance.render();
			}
			if (this.dxStockActualSalesDevelopmentRangSelct && this.dxStockActualSalesDevelopmentRangSelct.instance) {
				this.dxStockActualSalesDevelopmentRangSelct.instance.render();
			}
		});
	}
	formatCurrcy = function (values) {
		return UtilsService.FormatNumberWithDecimalPlaces(values, 6);
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotStockDeepDive").subscribe(result => {
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipStockDeepDive != null
				&& result[0].defaultSelectionTooltipStockDeepDive.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipStockDeepDive != null
				&& result[0].enableDisableTooltipStockDeepDive.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	pageName: string = "StockDeepDive";
	dataFilter: BookmarkData;

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	loadBookMarkFilter() {
		if (this.dataGrid != null && this.dataGrid.instance != null) {
			this.dataGrid.instance.clearFilter();
		}
		let filterData = Object.assign({}, this.dataFilter);
		filterData.name = "BokmkN";
		this.ChartSettings = null;
		this.taskService.LoadBookmarkData(filterData).subscribe(RData => {
			if (RData != null && RData.table != null && RData.table.length > 0) {
				if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != "") {
					this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
				}
				this.onResize();
				this.loadLengendToShare();
				this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
					data.forEach(element => {
						let ArrItem = JSON.parse(element.settingValue);
						if (ArrItem != null && ArrItem.length > 0) {
							this.dataGrid.instance.beginUpdate();
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
							this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', ArrItem);
							this.dataGrid.instance.endUpdate();
						}
					});
				}, err => {
				});
			}
		}, err => {
		});
	}
	anyActiveFilters = false;

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	loadLengendToShare() {
		let seriesValues = { StockDevelopment: [], StockActualSalesDevelopment: [], ScopeList: [] };
		if (this.dxStockDevelopmentChart != null && this.dxStockDevelopmentChart.instance != null
			&& this.dxStockDevelopmentChart.instance.getAllSeries() != null) {
			this.dxStockDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.StockDevelopment.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxstockActualSalesDevelopmentChart != null && this.dxstockActualSalesDevelopmentChart.instance != null
			&& this.dxstockActualSalesDevelopmentChart.instance.getAllSeries() != null) {
			this.dxstockActualSalesDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.StockActualSalesDevelopment.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {

		if (this.dxStockDevelopmentChart != null && this.dxStockDevelopmentChart.series != null
			&& Array.isArray(this.dxStockDevelopmentChart.series) && this.dxStockDevelopmentChart.series.length > 0) {
			for (let index = 0; index < this.dxStockDevelopmentChart.series.length; index++) {
				this.dxStockDevelopmentChart.series[index].visible = true;
			}
		}

		if (this.dxstockActualSalesDevelopmentChart != null && this.dxstockActualSalesDevelopmentChart.series != null
			&& Array.isArray(this.dxstockActualSalesDevelopmentChart.series) && this.dxstockActualSalesDevelopmentChart.series.length > 0) {
			for (let index = 0; index < this.dxstockActualSalesDevelopmentChart.series.length; index++) {
				this.dxstockActualSalesDevelopmentChart.series[index].visible = true;
			}
		}

		if (this.ChartSettings != null) {

			if (this.ChartSettings.StockDevelopment != null && this.ChartSettings.StockDevelopment.length > 0) {
				if (this.dxStockDevelopmentChart != null && this.dxStockDevelopmentChart.series != null
					&& Array.isArray(this.dxStockDevelopmentChart.series) && this.dxStockDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxStockDevelopmentChart.series.length; index++) {
						this.ChartSettings.StockDevelopment.forEach(itemchrt => {
							if (this.dxStockDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxStockDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxStockDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxStockDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.StockActualSalesDevelopment != null && this.ChartSettings.StockActualSalesDevelopment.length > 0) {
				if (this.dxstockActualSalesDevelopmentChart != null && this.dxstockActualSalesDevelopmentChart.series != null
					&& Array.isArray(this.dxstockActualSalesDevelopmentChart.series) && this.dxstockActualSalesDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxstockActualSalesDevelopmentChart.series.length; index++) {
						this.ChartSettings.StockActualSalesDevelopment.forEach(itemchrt => {
							if (this.dxstockActualSalesDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxstockActualSalesDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxstockActualSalesDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxstockActualSalesDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}

			if (this.dxStockDevelopmentChart) { this.dxStockDevelopmentChart.instance.refresh(); }
			if (this.dxstockActualSalesDevelopmentChart) { this.dxstockActualSalesDevelopmentChart.instance.refresh(); }

		}
	} onClick(event) {

		let target = event.target || event.srcElement || event.currentTarget;
		let srcAttr = target.attributes.src;
		this.imgSrc = srcAttr.nodeValue;
		this.ImgTitle = target.title;
		this.ImageInfoPopup = true
	}

	ConvertToFormat(item) {


		try {
			return UtilsService.ConvertToFormats(item.dataType, item.value, item.dataFormat);
		}
		catch (e: unknown) {
			console.log("ConvertToFormat Error-", e);
		}
		return item.value;
	}

	handleChartsAndLegends() {
		console.log('this.dxStockDevelopmentChart.series', this.dxStockDevelopmentChart.series);
		for (let itemCaption = 0; itemCaption < this.stockChartCaption.length; itemCaption++) {
			if (this.dxStockDevelopmentChart != null && this.dxStockDevelopmentChart.series != null
				&& Array.isArray(this.dxStockDevelopmentChart.series) && this.dxStockDevelopmentChart.series.length > 0) {
				for (let index = 0; index < this.dxStockDevelopmentChart.series.length; index++) {

					if (this.dxStockDevelopmentChart.series[index].valueField != null
						&& (this.dxStockDevelopmentChart.series[index].valueField.toLowerCase() == this.stockChartCaption[itemCaption].fieldName.toLowerCase()
							|| this.dxStockDevelopmentChart.series[index].name.toLowerCase() == this.stockChartCaption[itemCaption].fieldName.toLowerCase())

					) {
						this.dxStockDevelopmentChart.series[index].name = this.stockChartCaption[itemCaption].captionName;
					}
				}
			}

			if (this.dxstockActualSalesDevelopmentChart != null && this.dxstockActualSalesDevelopmentChart.series != null
				&& Array.isArray(this.dxstockActualSalesDevelopmentChart.series) && this.dxstockActualSalesDevelopmentChart.series.length > 0) {
				for (let index = 0; index < this.dxstockActualSalesDevelopmentChart.series.length; index++) {

					if (this.dxstockActualSalesDevelopmentChart.series[index].valueField != null
						&& (this.dxstockActualSalesDevelopmentChart.series[index].valueField.toLowerCase() == this.stockChartCaption[itemCaption].fieldName.toLowerCase()
							|| this.dxstockActualSalesDevelopmentChart.series[index].name.toLowerCase() == this.stockChartCaption[itemCaption].fieldName.toLowerCase())

					) {
						this.dxstockActualSalesDevelopmentChart.series[index].name = this.stockChartCaption[itemCaption].captionName;
					}
				}
			}
		}
	}
}
